import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Tile = ({ to, image, label, meta, testId }) => (
  <Link to={to} className="group block" data-testid={testId}>
    <div className="aspect-[4/5] bg-gray-50 rounded-lg overflow-hidden mb-3">
      {image && (
        <img src={image} alt={label} className="w-full h-full object-contain mix-blend-multiply p-6 transition-transform duration-500 group-hover:scale-105" loading="lazy" />
      )}
    </div>
    <div className="flex items-center justify-between">
      <div>
        <p className="text-lg font-medium text-gray-900">{label}</p>
        <p className="text-sm text-gray-500">{meta}</p>
      </div>
      <ArrowRight className="h-4 w-4 text-gray-400 transition-transform group-hover:translate-x-1 group-hover:text-gray-900" />
    </div>
  </Link>
);

export const CategoryTiles = ({ brandId, overview }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10" data-testid="category-tiles">
    {overview.categories.map((c) => (
      <Tile key={c.slug} to={`/brand/${brandId}/lighting/${c.slug}`} image={c.image} label={c.label}
        meta={`${c.count} products`} testId={`category-tile-${c.slug}`} />
    ))}
    <Tile to={`/brand/${brandId}/families`} image={overview.familyImage} label="Browse by family"
      meta={`${overview.familyCount} families`} testId="category-tile-families" />
  </div>
);

export const FamilyTiles = ({ brandId, families }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10" data-testid="family-tiles">
    {families.map((f) => (
      <Tile key={f.slug} to={`/brand/${brandId}/families/${f.slug}`} image={f.image} label={f.name}
        meta={`${f.count} ${f.count === 1 ? 'version' : 'versions'}`} testId={`family-tile-${f.slug}`} />
    ))}
  </div>
);
